import { render } from "./CPTArchive.vue?vue&type=template&id=7b1ce6ef"
import script from "./CPTArchive.vue?vue&type=script&lang=js"
export * from "./CPTArchive.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\PA\\endocorpusa\\web\\app\\plugins\\pa-teams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/components/CPTArchive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b1ce6ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b1ce6ef', __exports__)) {
    api.reload('7b1ce6ef', __exports__)
  }
  
  module.hot.accept("./CPTArchive.vue?vue&type=template&id=7b1ce6ef", () => {
    api.rerender('7b1ce6ef', render)
  })

}


export default __exports__